// extracted by mini-css-extract-plugin
module.exports = {"backAction":"BoxInfo_backAction__27DdR","boxInfo":"BoxInfo_boxInfo__3SiEp","backActionSection":"BoxInfo_backActionSection__1sxBM"};